import QuestionnaireResponses from './QuestionnaireResponses';

export default QuestionnaireResponses;
